import { createFileRoute } from "@tanstack/react-router";
import { LogisticsPage } from "@/components/solutions/LogisticsPage";
import { logisticsSeo } from "@/lib/page-seo";

export const Route = createFileRoute("/solutions/logistics")({
  loader: ({ location }) => ({ href: location.href }),
  head: ({ loaderData }) => logisticsSeo(loaderData?.href ?? "/solutions/logistics"),
  component: LogisticsPage,
});
